import produce from 'immer';

export const Types = {
  POST_WEBHOOKINTEGRATION_REQUEST:
    '@webhookIntegration/POST_WEBHOOKINTEGRATION_REQUEST',
  POST_WEBHOOKINTEGRATION_RESPONSE:
    '@webhookIntegration/POST_WEBHOOKINTEGRATION_RESPONSE',
  PUT_WEBHOOKINTEGRATION_REQUEST:
    '@webhookIntegration/PUT_WEBHOOKINTEGRATION_REQUEST',
  PUT_WEBHOOKINTEGRATION_RESPONSE:
    '@webhookIntegration/PUT_WEBHOOKINTEGRATION_RESPONSE',
  GET_WEBHOOKINTEGRATION_CONFIGURATION_REQUEST:
    '@webhookIntegration/GET_WEBHOOKINTEGRATION_CONFIGURATION_REQUEST',
  GET_WEBHOOKINTEGRATION_CONFIGURATION_RESPONSE:
    '@webhookIntegration/GET_WEBHOOKINTEGRATION_CONFIGURATION_RESPONSE',
  GET_WEBHOOKINTEGRATION_LIST_EVENTS_REQUEST:
    '@webhookIntegration/GET_WEBHOOKINTEGRATION_LIST_EVENTS_REQUEST',
  GET_WEBHOOKINTEGRATION_LIST_EVENTS_RESPONSE:
    '@webhookIntegration/GET_WEBHOOKINTEGRATION_LIST_EVENTS_RESPONSE',
  DELETE_WEBHOOKINTEGRATION_REQUEST:
    '@webhookIntegration/DELETE_WEBHOOKINTEGRATION_REQUEST',
  DELETE_WEBHOOKINTEGRATION_RESPONSE:
    '@webhookIntegration/DELETE_WEBHOOKINTEGRATION_RESPONSE',
};

const INITIAL_STATE = {
  postWebhook: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getWebhookConfiguration: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  putWebhookIntegration: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getWebhookListEvents: {
    success: false,
    error: null,
    loading: false,
    data: [],
  },
};

export default function webhookIntegration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_WEBHOOKINTEGRATION_CONFIGURATION_REQUEST: {
        draft.getWebhookConfiguration.loading = true;
        break;
      }
      case Types.GET_WEBHOOKINTEGRATION_CONFIGURATION_RESPONSE: {
        draft.getWebhookConfiguration.loading = false;
        draft.getWebhookConfiguration.data = action.payload.response;
        draft.getWebhookConfiguration.success = action.payload.success;
        draft.getWebhookConfiguration.error = false;
        break;
      }
      case Types.GET_WEBHOOKINTEGRATION_LIST_EVENTS_REQUEST: {
        draft.getWebhookListEvents.loading = true;
        break;
      }
      case Types.GET_WEBHOOKINTEGRATION_LIST_EVENTS_RESPONSE: {
        draft.getWebhookListEvents.loading = false;
        draft.getWebhookListEvents.data = action.payload.response;
        draft.getWebhookListEvents.success = action.payload.success;
        draft.getWebhookListEvents.error = false;
        break;
      }
      case Types.POST_WEBHOOKINTEGRATION_REQUEST: {
        draft.postWebhook.loading = true;
        break;
      }
      case Types.POST_WEBHOOKINTEGRATION_RESPONSE: {
        draft.postWebhook.loading = false;
        draft.postWebhook.data = action.payload.response;
        draft.postWebhook.success = action.payload.success;
        draft.postWebhook.error = false;
        break;
      }

      case Types.PUT_WEBHOOKINTEGRATION_REQUEST: {
        draft.getWebhookConfiguration.loading = true;
        break;
      }
      case Types.PUT_WEBHOOKINTEGRATION_RESPONSE: {
        draft.getWebhookConfiguration.loading = false;
        draft.getWebhookConfiguration.data = action.payload.response;
        draft.getWebhookConfiguration.success = action.payload.success;
        draft.getWebhookConfiguration.error = false;
        break;
      }
      case Types.DELETE_WEBHOOKINTEGRATION_REQUEST: {
        draft.getWebhookConfiguration.loading = true;
        break;
      }
      case Types.DELETE_WEBHOOKINTEGRATION_RESPONSE: {
        draft.getWebhookConfiguration.loading = false;
        draft.getWebhookConfiguration.data = action.payload.response;
        draft.getWebhookConfiguration.success = action.payload.success;
        draft.getWebhookConfiguration.error = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  postWebhookIntegrationRequest: () => ({
    type: Types.POST_WEBHOOKINTEGRATION_REQUEST,
  }),
  postWebhookIntegrationResponse: (response, success) => ({
    type: Types.POST_WEBHOOKINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
  getWebhookConfigurationRequest: () => ({
    type: Types.GET_WEBHOOKINTEGRATION_CONFIGURATION_REQUEST,
  }),
  getWebhookConfigurationResponse: (response, success) => ({
    type: Types.GET_WEBHOOKINTEGRATION_CONFIGURATION_RESPONSE,
    payload: { response, success },
  }),
  getWebhookListEventsRequest: () => ({
    type: Types.GET_WEBHOOKINTEGRATION_LIST_EVENTS_REQUEST,
  }),
  getWebhookListEventsResponse: (response, success) => ({
    type: Types.GET_WEBHOOKINTEGRATION_LIST_EVENTS_RESPONSE,
    payload: { response, success },
  }),
  putWebhookIntegrationRequest: (params) => ({
    type: Types.PUT_WEBHOOKINTEGRATION_REQUEST,
    payload: { params },
  }),
  putWebhookIntegrationResponse: (response, success) => ({
    type: Types.PUT_WEBHOOKINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
  deleteWebhookIntegrationRequest: (idWebhook) => ({
    type: Types.DELETE_WEBHOOKINTEGRATION_REQUEST,
    payload: idWebhook,
  }),
  deleteWebhookIntegrationResponse: (response, success) => ({
    type: Types.DELETE_WEBHOOKINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
};
